/**
 * Organization Switcher Component
 * Allows users to switch between organizations (multi-tenant support)
 * Hidden when URL maps to a valid organization (except for admin user)
 */

import { saveState } from '../store';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Building2 } from 'lucide-react';
import { getOrgFromUrl } from '../utils/urlToOrg';
import { useApp } from '../providers/AppProvider';

export function OrganizationSwitcher() {
  const { state, setState } = useApp();
  
  // Check if URL maps to a valid organization
  const urlOrgId = getOrgFromUrl();
  
  // Check if current user is admin
  const isAdminUser = state?.currentUser?.email === 'admin@gmail.com';

  const handleOrgChange = (orgId: string) => {
    const newOrg = state.organizations.find(o => o.id === orgId);
    if (newOrg) {
      const updatedState = {
        ...state,
        currentOrganization: newOrg,
      };
      saveState(updatedState);
      setState(updatedState);
      // Reload the page to refresh all data
      window.location.reload();
    }
  };

  // Don't render if no organization is set
  if (!state.currentOrganization || state.organizations.length === 0) {
    return null;
  }
  
  // Hide dropdown if URL maps to valid organization (unless admin user)
  if (urlOrgId && !isAdminUser) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <Building2 className="h-4 w-4 text-muted-foreground" />
      <Select
        value={state.currentOrganization.id}
        onValueChange={handleOrgChange}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {state.organizations.map((org) => (
            <SelectItem key={org.id} value={org.id}>
              {org.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}